var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("hi "+_vm._s(_vm.$store.getters.userName)+" here are your orders")])])}
var staticRenderFns = []

export { render, staticRenderFns }